export default {
  REDUX_NAMESPACE: 'IULI/PERMISSIONS',

  SET_CURRENT_PERMISSIONS: 'PERMISSIONS/SET_CURRENT_PERMISSIONS',
};
